const config = {
    build_number: '615857',
    build_timestamp: '2026-09-04T19:35:05.406Z',
    build_commit: '2e2616831fd9f0b5381e8e643fe1ed0f60cb7bb9',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
